import HeaderMenu from "./features/animation/headerMenu.es6";

export default class Common {
    constructor() {
        this.init();
    }

    init() {
        document.body.classList.add("-ready");
        const headerMenu = new HeaderMenu();
    }
}

new Common();
